module.exports = {
	init: () => {
		const searchResults = $(".search-results");
		if (!searchResults) {
			return;
		} 

		const addHiddenClass = () => {
			const facets = $(".search-filters .facetwp-facet");
			facets.each((i, el) => {
				const isHidden = el.classList.contains("is-hidden");
				const isCheckbox = el.classList.contains("facetwp-type-checkboxes")
				const isEmptyCheckbox = el.classList.contains("facetwp-type-checkboxes") && $(el).children('*:not(.disabled)[data-value=1]').length == 0;

				if(isCheckbox){
					if(isEmptyCheckbox){
						$(el.parentElement).addClass("is-hidden"); 
					}
					else{
						$(el.parentElement).removeClass("is-hidden"); 
					}
				}
				else{
					if (isHidden) {
						$(el.parentElement).addClass("is-hidden");
					}
					else{
						$(el.parentElement).removeClass("is-hidden");
					}
				} 
			});
		}
		
		$(document).ready(()=>{FWP.refresh()})
		document.addEventListener('facetwp-loaded', ()=>setTimeout(addHiddenClass,0.2*1000)); 
		//document.addEventListener('facetwp-refresh', addHiddenClass); 

	},
};
